module.exports = __webpack_public_path__ + "img/appAsset--pdf-ax.1132efdd.svg";